import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import IconButton from 'components/IconButton'
import Icon from 'components/Icon'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'

const TooltipPopover = ({
  icon,
  label,
  iconButtonProps,
  tooltipProps,
  tooltipContents,
  open,
  onClose,
  onOpen,
  containerProps,
  popperProps,
  preventClickAway,
  hover,
  tooltipClassname,
}) => {
  const [active, setActive] = useState(false)

  const handleMouseEnter = () => {
    if (hover) setActive(true)
  }

  const handleMouseLeave = () => {
    if (hover) setActive(false)
  }

  const handleToggleOpen = () => {
    if (!hover) setActive(prev => !prev)
  }

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (!hover) setActive(false)
      }}
    >
      <Box
        display="inline-grid"
        justifyContent="flex-start"
        {...containerProps}
      >
        <Tooltip
          open={active}
          arrow
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="bottom"
          componentsProps={{
            tooltip: {
              className: tooltipClassname,
            },
          }}
          title={tooltipContents}
          {...tooltipProps}
          PopperProps={popperProps}
        >
          <Box
            display="inline-grid"
            justifyContent="flex-start"
            {...containerProps}
          >
            {label && (
              <span
                onMouseUp={handleToggleOpen}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {label}
              </span>
            )}
            {!label && (
              <IconButton 
                {...iconButtonProps} 
                onMouseUp={handleToggleOpen}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Icon icon={icon} />
              </IconButton>
            )}
          </Box>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  )
}

TooltipPopover.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.node,
  iconButtonProps: PropTypes.object,
  tooltipProps: PropTypes.object,
  tooltipContents: PropTypes.any,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  containerProps: PropTypes.object,
  popperProps: PropTypes.object,
  preventClickAway: PropTypes.bool,
  hover: PropTypes.bool,
  tooltipClassname: PropTypes.string,
}

TooltipPopover.defaultProps = {
  icon: 'MoreVertical',
  iconButtonProps: {},
  tooltipProps: {},
  containerProps: {},
  popperProps: {},
  tooltipClassname: 'paper',
}

export default TooltipPopover
